import { render, staticRenderFns } from "./RegModal.vue?vue&type=template&id=84dccefa&scoped=true&"
import script from "./RegModal.vue?vue&type=script&lang=js&"
export * from "./RegModal.vue?vue&type=script&lang=js&"
import style0 from "./RegModal.vue?vue&type=style&index=0&id=84dccefa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dccefa",
  null
  
)

export default component.exports